import { useEffect, useState } from "react";

// Idea families in words and on the page (src/lib/ideas/families.js keeps them): how an idea came
// from another, and its family as the reader may see it.
export const CAME_FROM = { grew: "Grown from", bred: "Bred from", edited: "Edited from", variation: "A variation of", modified: "Changed from",
  heard: "Written down from", banded: "A band behind", remixed: "Remixed from", captured: "Back from a DAW, from" };
export const HOW_WORD = { grew: "Grew", bred: "Bred", edited: "Edited", variation: "Variation", modified: "Changed", heard: "Heard", banded: "Band", remixed: "Remixed", captured: "Captured" };
export const KIN_WORD = { copy: "Copy", variation: "Variation", "inspired by": "Inspired by" };
// "Edited · 81%": how it changed and how alike it stayed.
export const badge = (member) => [HOW_WORD[member.how] || member.how, member.similarity != null ? `${member.similarity}%` : null].filter(Boolean).join(" · ");
export const ideaApi = (ref, query = "") => `/api/ideas/${ref.split("/").map(encodeURIComponent).join("/")}${query}`;
export const familyHref = (ref) => `/i/${ref}?view=family`;

// An idea's family ({ parents, children, counts }), or null while it loads or when there's none.
export function useFamily(ref) {
  const [family, setFamily] = useState(null);
  useEffect(() => {
    if (!ref) { setFamily(null); return undefined; }
    let alive = true;
    setFamily(null);
    fetch(ideaApi(ref, "?family=1"), { credentials: "same-origin", cache: "no-store" })
      // (The body is read either way: one left unread keeps the request open.)
      .then((response) => response.json().catch(() => null).then((data) => response.ok ? data : null)).then((data) => { if (alive) setFamily(data?.family || null); }).catch(() => {});
    return () => { alive = false; };
  }, [ref]);
  return family;
}
